import React from "react";

import { faCalendar, faSearch, faStream, faUser } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { faUserFriends } from "@awesome.me/kit-4c83d50d0d/icons/kit/custom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import queryString from "query-string";

import { getSavedData, type VisitedItem } from "~/lib/searchHistory";
import JumpToResultWrapper from "~/search/JumpTo/JumpToResult/JumpToResultWrapper";
import { LazyAvatar } from "~/ui/legacy/Avatar";

import styles from "./JumpTo.module.css";

interface RecentSearchProp {
	query: string;
}

function RecentSearch({ query }: RecentSearchProp) {
	const link = `/search?${queryString.stringify({ q: query })}`;

	return <JumpToResultWrapper icon={<FontAwesomeIcon fixedWidth icon={faSearch} />} title={query} to={link} />;
}

function RecentlyVisited({ item }: { item: VisitedItem }) {
	let icon: React.ReactElement;

	switch (item.type) {
		case "meeting":
			icon = <FontAwesomeIcon fixedWidth icon={faCalendar} />;
			break;
		case "oneonone":
			icon = icon = item.otherUser ? (
				<LazyAvatar width="16px" userId={item.otherUser.id} preloader={<FontAwesomeIcon fixedWidth icon={faUser} />} />
			) : (
				<FontAwesomeIcon fixedWidth icon={faUserFriends} />
			);
			break;
		case "personal": {
			icon = <FontAwesomeIcon fixedWidth icon={faStream} />;
			break;
		}
	}

	return <JumpToResultWrapper icon={icon} title={item.displayName || item.name || ""} to={item.url} key={item.url} />;
}

export default function RecentSearches() {
	const { visited, searches } = getSavedData();

	return (
		<>
			{visited.length > 0 && (
				<div className={styles.section}>
					<span>Recent notes</span>
					{visited.map(recent => (
						<RecentlyVisited key={recent.id} item={recent} />
					))}
				</div>
			)}
			{searches.length > 0 && (
				<div className={styles.section}>
					<span>Recent searches</span>
					{searches.map(recentSearch => (
						<RecentSearch query={recentSearch} key={recentSearch} />
					))}
				</div>
			)}
		</>
	);
}
